import { WriteRequest } from "~/backendApis/foundation/WriteRequest"
import { ApiClient } from "~/backendApis/foundation/ApiClient"
import { UploadedFileResponse } from "~/backendApis/viewModel/file"

interface Params {
  corporationLogoImage: Blob
}

export class UploadCorporationLogoImageWriteRequest extends WriteRequest<UploadedFileResponse> {
  private readonly endpoint = "/file/corporation/corporation_logo_image/upload"
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public post(): Promise<UploadedFileResponse> {
    const formData = new FormData()
    formData.append("image", this.params.corporationLogoImage)

    return this.apiClient.post(
      this.endpoint,
      formData,
      ApiClient.MULTIPART_CUSTOM_HEADER
    )
  }
}
